export async function fetchSharpCharts2InspectorData(sharpChartsImageData: SharpCharts2UrlParameterImageData) {
  const urlSearchParams = new URLSearchParams({
    ...sharpChartsImageData,
    randomNumber: Date.now().toString(),
    img: 'text',
    inspector: 'yes'
  });

  const response = await fetch(`/c-sc/sc?${urlSearchParams.toString()}`, {
    method: 'GET',
    credentials: 'include'
  });

  const responseText = await response.text();

  if (!responseText.trim()) {
    throw new Error(`Error while fetching SharpCharts2 inspector data for url parameters: ${urlSearchParams.toString()} - trimmed responseText is an empty string.`);
  }

  return responseText.trim();
}
